[
  {
    "file": "aws.svg",
    "name": "AWS"
  },
  {
    "file": "googlecloud.svg",
    "name": "Google Cloud"
  },
  {
    "file": "docker.svg",
    "name": "Docker"
  },
  {
    "file": "linux.svg",
    "name": "Linux"
  },
  {
    "file": "nginx.svg",
    "name": "Nginx"
  },
  {
    "file": "caddy.svg",
    "name": "Caddy"
  },
  {
    "file": "webrtc.svg",
    "name": "WebRTC"
  },
  {
    "file": "javascript.svg",
    "name": "JavaScript"
  },
  {
    "file": "typescript.svg",
    "name": "TypeScript"
  },
  {
    "file": "python.svg",
    "name": "Python"
  },
  {
    "file": "cplusplus.svg",
    "name": "C++"
  },
  {
    "file": "nextdotjs.svg",
    "name": "Next.js"
  },
  {
    "file": "react.svg",
    "name": "React"
  },
  {
    "file": "angular.svg",
    "name": "Angular"
  },
  {
    "file": "gsap.svg",
    "name": "GSAP"
  },
  {
    "file": "nodedotjs.svg",
    "name": "Node.js"
  },
  {
    "file": "express.svg",
    "name": "Express"
  },
  {
    "file": "firebase.svg",
    "name": "Firebase"
  },
  {
    "file": "flutter.svg",
    "name": "Flutter"
  },
  {
    "file": "mysql.svg",
    "name": "MySQL"
  },
  {
    "file": "mongodb.svg",
    "name": "MongoDB"
  },
  {
    "file": "postgresql.svg",
    "name": "PostgreSQL"
  },
  {
    "file": "supabase.svg",
    "name": "Supabase"
  },
  {
    "file": "apachespark.svg",
    "name": "Apache Spark"
  },
  {
    "file": "pm2.svg",
    "name": "PM2"
  },
  {
    "file": "git.svg",
    "name": "Git"
  },
  {
    "file": "github.svg",
    "name": "GitHub"
  },
  {
    "file": "postman.svg",
    "name": "Postman"
  }
]
